import React, { useState } from "react";
import {
  Button,
  Chip,
  Container,
  Grid,
  Stack,
  Typography,
} from "@mui/material";
import { graphql } from "gatsby";
import NavigationWrapper from "../components/layout/NavigationWrapper";
import ArticleCard from "../components/sections/Article/ArticleCard";
import SEO from "../components/Seo";
import {
  filterOutDocsPublishedInTheFuture,
  filterOutDocsWithoutSlugs,
  mapEdgesToNodes,
} from "../lib/helpers";
import COLORS from "../constants/colors";
import { AllSanityPosts } from "../interfaces/sanity/sanityClasses";
import { articleHasCategory, getAllCategories } from "../utils/sanity";
import PodcastShowCase from "../components/sections/PodcastShowcase";
import seoPresserom from "../assets/images/seo-presserom.png";
import useIsMobile from "../hooks/useIsMobile";
import ArticleCardGrid from "../components/ArticleCardGrid";

export const query = graphql`
  query PostsQuery {
    allSanityPost(sort: { sortDate: DESC }) {
      edges {
        node {
          id
          mainImage {
            asset {
              _id
            }
          }
          title
          slug {
            current
          }
          excerpt
          previewImage {
            asset {
              _id
            }
          }
          categories {
            title
            description
            id
          }
        }
      }
    }
  }
`;

const BloggPage = ({ data }: AllSanityPosts) => {
  const [articleCount, setArticleCount] = useState(9);
  const [categoryFilter, setCategoryFilter] = useState<string | null>(null);

  // All articles
  const articles = data.allSanityPost
    ? mapEdgesToNodes(data.allSanityPost)
        .filter(filterOutDocsWithoutSlugs)
        .filter(filterOutDocsPublishedInTheFuture)
    : [];

  // Articles filtered on category
  const filteredArticles = articles.filter((article) =>
    categoryFilter ? articleHasCategory(article, categoryFilter) : true
  );

  // All categories
  const categories = getAllCategories(articles);
  return (
    <NavigationWrapper>
      <Container>
        <Stack>
          <Stack component="section" pb="48px" pt="12px">
            <Stack gap="24px">
              <Typography variant="h1" color={COLORS.BRIGHT_BLUE[60]}>
                Artikler
              </Typography>

              <Typography>
                Vi har én regel - vi snakker om økonomi på <br /> en måte alle
                kan henge med på.
              </Typography>
            </Stack>
            <Stack
              direction="row"
              gap="8px"
              maxWidth="500px"
              flexWrap="wrap"
              my="60px"
            >
              {categories.map((category, index) => (
                <Stack key={index}>
                  <Chip
                    label={category.title}
                    color={
                      categoryFilter === category.id ? "secondary" : "primary"
                    }
                    onClick={() => {
                      setCategoryFilter(category.id);
                    }}
                    aria-label={`Vis artikler om ${category.title}`}
                  />
                </Stack>
              ))}
              <Chip
                label="Vis alle"
                color={categoryFilter ? "primary" : "secondary"}
                onClick={() => {
                  setCategoryFilter(null);
                }}
                aria-label="Vis alle artikler"
              />
            </Stack>
            <ArticleCardGrid
              articles={filteredArticles.slice(0, articleCount)}
            />

            <Stack alignItems="center" mt="60px">
              {articleCount < filteredArticles.length && (
                <Button
                  variant="contained"
                  onClick={() => setArticleCount(articleCount + 9)}
                >
                  Vis flere artikler
                </Button>
              )}
            </Stack>
          </Stack>
        </Stack>
      </Container>
      <Stack
        component="section"
        bgcolor={COLORS.BRIGHT_BLUE[20]}
        py={{
          xs: "48px",
          md: "86px",
        }}
      >
        <Container
          maxWidth="lg"
          sx={{
            paddingX: { xs: "0px", md: "22px" },
          }}
        >
          <PodcastShowCase
            bgcolor={COLORS.BRIGHT_BLUE[40]}
            borderRadius="16px"
          />
        </Container>
      </Stack>
    </NavigationWrapper>
  );
};

export default BloggPage;

export function Head() {
  return (
    <SEO
      title="Artikler - Horde"
      description="Privatøkonomi skal ikke være vanskelig. I horde sine artikler får du nyttig informasjon om hvordan din økonomi kan bli bedre."
      image={seoPresserom}
    />
  );
}
